import {normalizeDecimalInput} from "../../utils/convert-fields"
import {formatDecimalSeparator} from "src/v2/utils/formatter/format-number"
import {removeTableHeader} from "src/v2/utils/table-clipboard"

const NUMBER_FIELDS = new Set(["valorPercentual", "valorFinanceiro"])

export const formatExtraordinarioCopyValue = (field, value) =>
    NUMBER_FIELDS.has(field) ? formatDecimalSeparator(normalizeDecimalInput(value), "") : String(value ?? "")

const NUMBER_LABELS = {valorPercentual: "Valor Percentual", valorFinanceiro: "Valor Financeiro"}

const normalizeCell = (field, value, line) => {
    if (!NUMBER_FIELDS.has(field)) return value
    try {
        return normalizeDecimalInput(value)
    } catch (_error) {
        throw new Error(`Linha ${line}: valor inválido em ${NUMBER_LABELS[field]}.`)
    }
}

export const normalizeExtraordinariosPaste = (cells, {startColIndex = 0, columnsOrder, columnsConfig = [], mode}) => {
    const rows = mode === "replaceAll"
        ? removeTableHeader(cells, columnsOrder, columnsOrder.map(field =>
            columnsConfig.find(column => column.field === field)?.headerName || field
        ))
        : cells
    const firstLine = mode === "replaceAll" ? 2 : 1
    if (mode === "replaceAll") {
        const emptyRowIndex = rows.findIndex(row => !row.some(value => String(value).trim()))
        if (emptyRowIndex !== -1) {
            throw new Error(`Linha ${emptyRowIndex + firstLine}: linha vazia na planilha.`)
        }
    }
    return rows.map((row, index) =>
        row.map((value, offset) => normalizeCell(columnsOrder[startColIndex + offset], value, index + firstLine))
    )
}

export const validateExtraordinariosRows = (rows) => {
    rows.forEach((row, index) => NUMBER_FIELDS.forEach(field => normalizeCell(field, row?.[field], index + 1)))
}
